module.exports = __webpack_public_path__ + "static/media/orgBg.bca9a962.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/orgBg.jpg
// module id = 1827
// module chunks = 0 1